import { all } from 'redux-saga/effects';

import { authSagas } from '../../modules/auth/saga';
import { buildingSagas } from '../../modules/building/saga';
import { dashboardSagas } from '../../modules/dashboard/saga';
import { dwellingSagas } from '../../modules/dwelling/saga';
import { teamSagas } from '../../modules/myTeam/sagas';
import { OrderViewSagas } from '../../modules/order/saga';
import { OrderSagas } from '../../modules/orders/saga';
import { groupSagas, agencySagas } from '../../modules/profile/sagas';
import { serviceOrderingSagas } from '../../modules/serviceOrdering/sagas';

export function* rootSaga() {
  yield all([
    ...authSagas,
    ...buildingSagas,
    ...serviceOrderingSagas,
    ...groupSagas,
    ...agencySagas,
    ...dwellingSagas,
    ...OrderSagas,
    ...teamSagas,
    ...OrderViewSagas,
    ...dashboardSagas
  ]);
}
